/* Sohi — flavour rail. Chevron pages forward and wraps at the end. */
(function () {
  "use strict";

  function init(section) {
    if (section.dataset.sohiReady === "true") return;
    section.dataset.sohiReady = "true";

    var rail = section.querySelector(".rail");
    var cups = section.querySelectorAll(".cup");
    var next = section.querySelector("[data-rail-next]");
    if (!rail || !cups.length || !next) return;

    function step() {
      var gap = parseFloat(getComputedStyle(rail).gap) || 0;
      return cups[0].getBoundingClientRect().width + gap;
    }
    function atEnd() {
      return rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 2;
    }
    function syncChev() {
      next.disabled = rail.scrollWidth - rail.clientWidth < 24;
    }

    next.addEventListener("click", function () {
      if (atEnd()) rail.scrollTo({ left: 0, behavior: "smooth" });
      else rail.scrollBy({ left: step(), behavior: "smooth" });
    });

    window.addEventListener("resize", syncChev);
    syncChev();
  }

  function boot(root) {
    (root || document).querySelectorAll("[data-flavours]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener("shopify:section:load", function (e) { boot(e.target); });
})();
